export default "__VITE_ASSET__d72cb946__"